import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import type { Dispatch } from '@tmapy/redux';
import { useMessage } from '@tmapy/intl';

import {
  BtnBar,
  Form,
  FormItem,
  Input,
  CtaBtn,
  SecondaryBtn,
  StickyFooter,
} from '@tmapy/style-guide';

import { useInput } from '../../hooks';
import { setOrganizationsListFilter } from '../../redux/filter/actions';
import { OrganizationsListQuery } from '../../openapi/operations/organizationsList';
import { organizationMessages, organizationBtnMessages } from './organizationMessages';

type OrganizationFiltersProps = {
  filters: OrganizationsListQuery;
  dispatch: Dispatch;
};

export const OrganizationFilter: React.FC<OrganizationFiltersProps> = ({ filters, dispatch }) => {
  const formatMessage = useMessage();

  const name = useInput({
    name: 'name',
    initialValue: filters.name__icontains,
    label: formatMessage(organizationMessages.name),
  });

  const ico = useInput({
    name: 'ico',
    initialValue: filters.ico__icontains,
    label: formatMessage(organizationMessages.ico),
  });

  const dic = useInput({
    name: 'dic',
    initialValue: filters.dic__icontains,
    label: formatMessage(organizationMessages.dic),
  });

  const search = useInput({
    name: 'search',
    initialValue: filters.search,
    label: formatMessage(organizationMessages.search),
  });

  // CLEAR FORM
  const filterClearScope = [search, ico, name, dic];
  const handleClearBtnClick = useCallback(() => {
    filterClearScope.forEach((formItem) => formItem?.clear?.());
    dispatch(setOrganizationsListFilter({}));
  }, [dispatch]);

  // SUBMIT FORM
  const handleSubmit = () => {
    dispatch(
      setOrganizationsListFilter({
        search: search.value,
        name__icontains: name.value,
        ico__icontains: ico.value,
        dic__icontains: dic.value,
      }),
    );
  };

  return (
    <Form onSubmit={handleSubmit}>
      <div className='sg-u-vs-2'>
        <FormItem {...search}>
          <Input {...search} />
        </FormItem>
        <FormItem {...name}>
          <Input {...name} />
        </FormItem>
        <FormItem {...ico}>
          <Input {...ico} />
        </FormItem>
        <FormItem {...dic}>
          <Input {...dic} />
        </FormItem>
      </div>
      <StickyFooter>
        <BtnBar stretch>
          <CtaBtn type='submit'>
            <FormattedMessage {...organizationBtnMessages.filterSubmit} />
          </CtaBtn>
          <SecondaryBtn isDanger onClick={handleClearBtnClick}>
            <FormattedMessage {...organizationBtnMessages.clear} />
          </SecondaryBtn>
        </BtnBar>
      </StickyFooter>
    </Form>
  );
};
